import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, X } from 'lucide-react';
import ImageUpload from './ImageUpload';
import { toast } from 'sonner';

const GalleryManager = ({ gallery = [], onGalleryUpdate }) => {
  const [showUpload, setShowUpload] = useState(false);
  const MAX_PHOTOS = 6;

  const handleAddPhoto = (imageUrl) => {
    if (gallery.length >= MAX_PHOTOS) {
      toast.error(`Maximum ${MAX_PHOTOS} photos allowed`);
      return;
    }
    const newGallery = [...gallery, imageUrl];
    onGalleryUpdate(newGallery);
    setShowUpload(false);
    toast.success('Photo added to gallery');
  };

  const handleRemovePhoto = (index) => {
    const newGallery = gallery.filter((_, i) => i !== index);
    onGalleryUpdate(newGallery);
    toast.success('Photo removed from gallery');
  };

  return (
    <div className="space-y-4" data-testid="gallery-manager">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-white">Gallery ({gallery.length}/{MAX_PHOTOS} photos)</label>
        {gallery.length < MAX_PHOTOS && !showUpload && (
          <Button onClick={() => setShowUpload(true)} size="sm" className="bg-primary" data-testid="add-photo-button">
            <Plus className="w-4 h-4 mr-1" /> Add Photo
          </Button>
        )}
      </div>

      {showUpload && (
        <div className="bg-zinc-900/50 border border-white/10 rounded-xl p-4">
          <ImageUpload imageType="gallery" currentImage={null} onImageUploaded={handleAddPhoto} label="Upload Gallery Photo (1:1 ratio recommended)" aspectRatio="square" />
          <Button onClick={() => setShowUpload(false)} variant="ghost" size="sm" className="mt-2 text-muted-foreground">Cancel</Button>
        </div>
      )}

      {gallery.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {gallery.map((photo, index) => (
            <div key={index} className="relative group" data-testid={`gallery-photo-${index}`}>
              <img src={photo} alt={`Gallery ${index + 1}`} className="w-full aspect-square object-cover rounded-xl border border-white/10" />
              <button onClick={() => handleRemovePhoto(index)} className="absolute top-2 right-2 w-8 h-8 rounded-full bg-destructive flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`remove-photo-${index}`}>
                <X className="w-4 h-4 text-white" />
              </button>
            </div>
          ))}
        </div>
      )}

      {gallery.length === 0 && !showUpload && (
        <div className="text-center py-8 border border-dashed border-white/10 rounded-xl" data-testid="empty-gallery">
          <p className="text-muted-foreground">No photos in gallery</p>
        </div>
      )}
    </div>
  );
};

export default GalleryManager;